var msal = require('@azure/msal-browser');
const config = require("./Config.js");

const MsalApi = {

    _accessToken: "",
    MSALInstance: null,
    _apiScope: "",

    initialize: function (onComplete) {

        let azureData = config.Azure;

        const msalConfig = {
            auth: {
                clientId: azureData.clientID,
                authority: `https://login.microsoftonline.com/${azureData.tenantID}`,
                knownAuthorities: [],
                redirectUri: azureData.redirectURI,
                postLogoutRedirectUri: azureData.redirectURI,
                navigateToLoginRequestUrl: true,
            },
            cache: {
                cacheLocation: "sessionStorage",
                storeAuthStateInCookie: false,
            },
            system: {
                loggerOptions: {
                    loggerCallback: (level, message, containsPii) => {
                        if (containsPii) {
                            return;
                        }
                        switch (level) {
                            case msal.LogLevel.Error:
                                console.error(message);
                                return;
                            case msal.LogLevel.Info:
                                console.info(message);
                                return;
                            case msal.LogLevel.Verbose:
                                console.debug(message);
                                return;
                            case msal.LogLevel.Warning:
                                console.warn(message);
                                return;
                        }
                    },
                    piiLoggingEnabled: false,
                },
                windowHashTimeout: 60000,
                iframeHashTimeout: 6000,
                loadFrameTimeout: 0,
            },
        };

        let apiScope = this._apiScope = azureData.apiScope;

        // Create an instance of PublicClientApplication
        let msalInstance = this.MSALInstance = new msal.PublicClientApplication(msalConfig);

        let accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
        }

        let self = this;

        msalInstance.addEventCallback((event) => {
            // set active account after redirect
            if (event.eventType === msal.EventType.LOGIN_SUCCESS && event.payload.account) {
                let account = event.payload.account;
                msalInstance.setActiveAccount(account);

                if (!self._accessToken) {
                    self._accessToken = event.payload.accessToken;
                }
            }
        }, error => {
            console.log('error', error);
        });

        msalInstance.handleRedirectPromise().then(() => {

            // Check if user signed in 
            let account = msalInstance.getActiveAccount();
            if (!account) {
                // redirect anonymous user to login page
                msalInstance.loginRedirect({ extraScopesToConsent: [apiScope] });
            }
            else {
                onComplete();
            }
        }).catch(err => {
            console.log(err);
        });
    },

    getToken: function (callback) {
        let tokenRequest = {
            scopes: [this._apiScope]
        }
        let self = this;

        this.MSALInstance.acquireTokenSilent(tokenRequest)
            .then(function (accessTokenResponse) {
                let accessToken = accessTokenResponse.accessToken;
                callback(accessToken);
            })
            .catch(function (error) {
                if (error.name === "InteractionRequiredAuthError") {
                    let response = self.MSALInstance.acquireTokenRedirect(tokenRequest);
                    let accessToken = response.accessToken;
                    callback(accessToken);
                }
                else {
                    throw error;
                }
            });
    }
};

module.exports = MsalApi;


// WEBPACK FOOTER //
// ./src/MsalApi.js